<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import PopOver from '@/src/components/pop-over.vue'
import BaseVidPLayer from '@components/_base-vidplayer.vue'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PopOver, BaseVidPLayer },
  methods: {
    fadeStage() {
      this.$refs.fadeStage.classList.add('go')
      setTimeout(() => {
        this.$router.push('/choose-path')
      }, 500)
    },
  },
}
</script>

<template>
  <Layout>
    <BaseVidPLayer
      ref="bgVideo"
      src="journey1-0.mp4"
      poster="journey1-0.png"
      next-path="01-A-exploration-planning"
      :pause="0.3"
    />
    <div ref="fadeStage" class="fadeStage">
      <PopOver
        :pos-x="33"
        :pos-y="20"
        pos-unit="%"
        pop-size="lg"
        pop-height="450px"
      >
        <img
          src="@assets/images/hexagon-logo.png"
          alt="Hexagon Logo"
          class="logo"
          style="width: 250px;"
        />
        <h1 class="tUpper m-t-5 m-b-5" style="font-size: 6rem;"
          >Life Of Mine</h1
        >
        <h3 class="m-t-5" style="font-weight: normal;">
          Experience the power of integrated solutions across your mining
          operation.
        </h3>
      </PopOver>
      <BaseButton
        class="z-5"
        style="position: absolute; top: 75%; left: 45%;"
        @click="fadeStage"
      >
        START
      </BaseButton>
    </div>
  </Layout>
</template>

<style lang="scss">
// Design
</style>
